module.exports = __webpack_public_path__ + "static/media/success-cart-curve-top.ef8d9340.svg";